export default __webpack_public_path__ + "static/media/finger4.8228dcff.png";